/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Templatelibrary_Emptystate2Inputs */

const en_settings_templatelibrary_emptystate2 = /** @type {(inputs: Settings_Templatelibrary_Emptystate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No templates available`)
};

/**
* | output |
* | --- |
* | "No templates available" |
*
* @param {Settings_Templatelibrary_Emptystate2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_templatelibrary_emptystate2 = /** @type {((inputs?: Settings_Templatelibrary_Emptystate2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templatelibrary_Emptystate2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_templatelibrary_emptystate2(inputs)
});
export { settings_templatelibrary_emptystate2 as "settings_templateLibrary_emptyState" }